import React from "react";
import "../css/ReviewsSection.css";

const googleIconPath = "/assets/icons/google.svg";

const GoogleIcon = ({ small }) => (
  <img
    src={googleIconPath}
    alt="Google"
    className={`google-icon ${small ? "google-icon--small" : ""}`}
  />
);

const StarRating = ({ rating, compact }) => {
  const stars = [];
  for (let i = 1; i <= 5; i++) {
    stars.push(
      <span
        key={i}
        className={`star ${compact ? "star--compact" : ""} ${
          i <= rating ? "star--filled" : "star--empty"
        }`}
      >
        {i <= rating ? "★" : "☆"}
      </span>
    );
  }
  return (
    <div className={`review-stars ${compact ? "review-stars--compact" : ""}`}>
      {stars}
    </div>
  );
};

const formatDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleDateString("it-IT", {
    year: "numeric",
    month: "long",
  });
};

const ReviewsSection = ({ reviews, variant = "default" }) => {
  const isCompact = variant === "compact";

  return (
    <section
      className={`reviews-section ${
        isCompact ? "reviews-section--compact" : ""
      }`}
    >
      <div className="section-content">
        <div className="section-header">
          <span className="section-subtitle">COSA DICONO DI NOI</span>
          <h2 className="section-title">
            {isCompact ? "Recensioni" : "Le Recensioni dei Nostri Clienti"}
          </h2>
        </div>

        <div className="reviews-container">
          <div
            className={`reviews-scroll ${
              isCompact ? "reviews-scroll--compact" : ""
            }`}
          >
            {/* Render reviews - duplicate for seamless loop in compact mode */}
            {(isCompact ? [...reviews, ...reviews] : reviews).map(
              (review, index) => (
                <div
                  key={`review-${
                    isCompact ? Math.floor(index / reviews.length) : 0
                  }-${index % reviews.length}`}
                  className={`review-card ${
                    isCompact ? "review-card--compact" : ""
                  }`}
                >
                  {isCompact && (
                    <div className="review-google-badge">
                      <GoogleIcon small />
                    </div>
                  )}
                  <div className="review-header">
                    <div
                      className={`reviewer-avatar ${
                        isCompact ? "reviewer-avatar--compact" : ""
                      }`}
                    >
                      {review.name.charAt(0).toUpperCase()}
                    </div>
                    <div className="reviewer-info">
                      <h4
                        className={`reviewer-name ${
                          isCompact ? "reviewer-name--compact" : ""
                        }`}
                      >
                        {review.name}
                      </h4>
                      <span
                        className={`review-date ${
                          isCompact ? "review-date--compact" : ""
                        }`}
                      >
                        {formatDate(review.date)}
                      </span>
                    </div>
                  </div>
                  <StarRating rating={review.rating} compact={isCompact} />
                  <p
                    className={`review-text ${
                      isCompact ? "review-text--compact" : ""
                    }`}
                  >
                    {review.text}
                  </p>
                </div>
              )
            )}
          </div>
        </div>

        {!isCompact && (
          <div className="reviews-footer">
            <a
              href="https://www.google.com/search?q=fer-al+firenze+recensioni"
              target="_blank"
              rel="noopener noreferrer"
              className="google-reviews-link"
            >
              <GoogleIcon />
              <span>Vedi tutte le recensioni su Google</span>
            </a>
          </div>
        )}
      </div>
    </section>
  );
};

export default ReviewsSection;
